
import { useEffect, useRef } from 'react';
import { useRoomData } from './use-room-data';
import { useRoomSubscription } from './use-room-subscription';
import { RealtimeChannel } from '@supabase/supabase-js';

export const useRoomState = (roomId: string | undefined) => {
  const channelRef = useRef<RealtimeChannel | null>(null);
  
  const {
    room,
    fetchRoomData,
    startGame,
  } = useRoomData(roomId);

  const {
    connectionStatus,
    subscribeToRoom: initSubscription,
  } = useRoomSubscription(roomId, async () => {
    await fetchRoomData();
  });

  useEffect(() => {
    let reconnectTimer: ReturnType<typeof setTimeout>;

    if (connectionStatus === 'disconnected' && roomId) {
      reconnectTimer = setTimeout(() => {
        console.log('Attempting to reconnect...');
        if (!channelRef.current) {
          channelRef.current = initSubscription();
        }
      }, 5000);
    }

    return () => {
      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
      }
    };
  }, [connectionStatus, roomId, initSubscription]);

  const subscribeToRoom = () => {
    if (channelRef.current) {
      console.log('Cleaning up existing channel subscription');
      channelRef.current.unsubscribe();
      channelRef.current = null;
    }
    
    console.log('Creating new room subscription');
    channelRef.current = initSubscription();
    return channelRef.current;
  };

  return {
    room,
    fetchRoomData,
    startGame,
    subscribeToRoom,
    connectionStatus,
  };
};
